import { CASE_STUDIES } from "@/lib/content";
import useSiteContent from "@/hooks/useSiteContent";

export default function CaseStudies() {
  const cms = useSiteContent();
  const items = cms.case_studies?.length ? cms.case_studies : CASE_STUDIES;
  return (
    <>
      <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="chapter-num">Case Studies</div>
          <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">Numbers,<br /><em className="italic text-[var(--pta-gold)]">not narratives.</em></h1>
          <p className="mt-8 max-w-2xl text-[var(--pta-ink)]/75 text-lg">Anonymized engagements from the last 24 months. Real outcomes, without the marketing gloss.</p>
        </div>
      </section>
      <section className="bg-[var(--pta-paper)] py-24">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((c, i) => (
            <article key={i} data-testid={`case-${i}`} className="pta-card bg-[var(--pta-cream)] border hairline p-10">
              <div className="font-mono-fine text-[11px] tracking-[0.22em] text-[var(--pta-gold)] uppercase">Case · 0{i + 1}</div>
              <div className="font-serif-display text-7xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-none">{c.number}</div>
              <h2 className="font-serif-display text-3xl text-[var(--pta-navy)] mt-4">{c.title}</h2>
              <p className="mt-4 text-[var(--pta-ink)]/70 leading-relaxed">{c.detail}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
